import React, { Component } from 'react';
import { css, cx } from 'emotion';
import { CaretDownMUI, CaretDownSUI, CheckmarkSUI, CheckmarkXsUI } from '@hig/icons';
import Input from '@hig/input';
import ThemeContext, { ThemeContext as ThemeContext$1 } from '@hig/theme-context';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import MultiDownshift from '@hig/multi-downshift';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function getActiveStyles(isOpen) {
  if (isOpen) {
    return {
      transform: "translateY(-50%) rotate(180deg)"
    };
  }
  return {
    transform: "translateY(-50%)"
  };
}

function stylesheet(props, themeData) {
  var padding = props.variant === "box" ? themeData["input.boxType.horizontalPadding"] : themeData["input.horizontalPadding"];
  var isOpen = props.isOpen;


  return {
    wrapper: {
      position: "relative"
    },
    caret: _extends({
      position: "absolute",
      top: "50%",
      right: padding,
      opacity: props.disabled ? themeData["component.disabled.opacity"] : 1,
      pointerEvents: "none",
      transition: "transform 0.3s, color 0.3s"
    }, getActiveStyles(isOpen))
  };
}

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function customStyles(inputStylesheet) {
  return _extends$1({}, inputStylesheet, {
    input: _extends$1({}, inputStylesheet.input, {
      cursor: "pointer"
    })
  });
}

function InputPresenter(props) {
  var isOpen = props.isOpen,
      otherProps = _objectWithoutProperties(props, ["isOpen"]);

  return React.createElement(
    ThemeContext.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles,
          metadata = _ref.metadata;

      var CaretIcon = metadata.densityId === "medium-density" ? CaretDownMUI : CaretDownSUI;
      var iconColor = isOpen ? resolvedRoles["colorScheme.accentColor"] : resolvedRoles["colorScheme.iconColor"];

      return React.createElement(
        "div",
        { className: css(stylesheet(props, resolvedRoles).wrapper) },
        React.createElement(Input, _extends$1({}, otherProps, { stylesheet: customStyles, readOnly: true })),
        React.createElement(CaretIcon, {
          style: stylesheet(props, resolvedRoles).caret,
          color: iconColor
        })
      );
    }
  );
}
InputPresenter.__docgenInfo = {
  "description": "",
  "displayName": "InputPresenter"
};

var constants = {
  dropdownLayer: 9996,
  optionHeight: "36px",
  menuMaxHeight: "360px"
  // menuTopOffset: "32px"
};

function stylesheet$1(props, themeData) {
  return {
    display: props.isOpen ? "block" : "none",
    position: "absolute",
    width: "100%",
    maxHeight: constants.menuMaxHeight,
    top: themeData["input.height"],
    overflow: "auto",
    zIndex: constants.dropdownLayer,
    boxSizing: "border-box",
    borderTop: "none",
    borderTopLeftRadius: themeData["menu.topFlushBorderTopRadius"],
    borderTopRightRadius: themeData["menu.topFlushBorderTopRadius"],
    borderBottomLeftRadius: themeData["menu.borderRadius"],
    borderBottomRightRadius: themeData["menu.borderRadius"],
    backgroundColor: themeData["menu.backgroundColor"],
    boxShadow: "0 1px " + themeData["basics.shadows.lowBlur"] + " " + themeData["colorScheme.lowShadowColor"]
  };
}

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function MenuPresenter(props) {
  var innerRef = props.innerRef,
      isOpen = props.isOpen,
      children = props.children,
      otherProps = _objectWithoutProperties$1(props, ["innerRef", "isOpen", "children"]);

  var className = otherProps.className;


  return React.createElement(
    ThemeContext$1.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles;
      return React.createElement(
        "div",
        _extends$2({}, otherProps, {
          ref: innerRef,
          className: cx(css(stylesheet$1(props, resolvedRoles)), className)
        }),
        children
      );
    }
  );
}

MenuPresenter.propTypes = {
  innerRef: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};
MenuPresenter.__docgenInfo = {
  "description": "",
  "displayName": "MenuPresenter",
  "props": {
    "innerRef": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

function stylesheet$2() {
  return {
    position: "relative",
    width: "100%"
  };
}

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @typedef {Object} WrapperProps
 * @property {JSX.Element} [input]
 * @property {JSX.Element} [menu]
 * @property {boolean} [isOpen]
 */

/**
 * Downshift requires a reference to the component's root element.
 * As a result, this presenter should be purely functional so that it can
 * be used as function with Downshift.
 *
 * @param {WrapperProps} prop
 * @returns {JSX.Element}
 * @see https://github.com/paypal/downshift#getrootprops
 */
function WrapperPresenter(props) {
  var disabled = props.disabled,
      children = props.children,
      otherProps = _objectWithoutProperties$2(props, ["disabled", "children"]);

  var className = otherProps.className;


  return React.createElement(
    "div",
    _extends$3({}, otherProps, { className: cx(css(stylesheet$2(props)), className) }),
    children
  );
}

WrapperPresenter.propTypes = {
  children: PropTypes.node
};
WrapperPresenter.__docgenInfo = {
  "description": "Downshift requires a reference to the component's root element.\nAs a result, this presenter should be purely functional so that it can\nbe used as function with Downshift.\n\n@param {WrapperProps} prop\n@returns {JSX.Element}\n@see https://github.com/paypal/downshift#getrootprops",
  "displayName": "WrapperPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof commonjsGlobal === 'undefined' ? 'undefined' : _typeof(commonjsGlobal)) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

/**
 * @typedef {Object} ButtonEventHandlers
 * @property {function(MouseEvent, ...any): void} handleClick
 * @property {function(KeyboardEvent, ...any): void} handleKeyDown
 */

/**
 * @typedef {Object} Options
 * @property {boolean} [preventDefault]
 */

var KEYBOARD_INTERACTIONS = [" ", "Enter"];

/**
 * Create event handlers for native button behavior for non-button elements
 * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role
 *
 * @param {function(MouseEvent|KeyboardEvent, ...any): void} [handler] the event handler function
 * @param {Options} [options]
 * @returns {ButtonEventHandlers}
 */
function createButtonEventHandlers(handler) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!handler) return {};

  var _options$preventDefau = options.preventDefault,
      preventDefault = _options$preventDefau === undefined ? true : _options$preventDefau;

  return {
    handleClick: handler,
    handleKeyDown: function handleKeyDown(event) {
      var key = event.key;

      if (!KEYBOARD_INTERACTIONS.includes(key)) return;
      // Prevent space key default scrolling behavior
      if (preventDefault) event.preventDefault();

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      handler.apply(undefined, [event].concat(_toConsumableArray(args)));
    }
  };
}

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function stylesheet$3(props, themeData) {
  return _extends$4({
    margin: 0,
    display: "flex",
    position: "relative",
    boxSizing: "border-box",
    minHeight: constants.optionHeight,
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 8px",
    cursor: "pointer",
    color: themeData["typography.body.color"],
    fontFamily: themeData["typography.body.fontFamily"],
    fontWeight: themeData["typography.body.fontWeight"],
    fontSize: themeData["typography.body.fontSize"],
    lineHeight: themeData["typography.body.lineHeight"],
    backgroundColor: "transparent"
  }, props.highlighted ? { backgroundColor: themeData["menu.item.hover.backgroundColor"] } : null, props.selected ? { backgroundColor: themeData["menu.item.focus.backgroundColor"] } : null);
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties$3(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function OptionWrapper(props) {
  var children = props.children,
      id = props.id,
      onClick = props.onClick,
      onMouseDown = props.onMouseDown,
      onMouseMove = props.onMouseMove,
      selected = props.selected,
      highlighted = props.highlighted;

  var _createButtonEventHan = createButtonEventHandlers(onClick),
      handleClick = _createButtonEventHan.handleClick,
      handleKeyDown = _createButtonEventHan.handleKeyDown;

  return React.createElement(
    ThemeContext$1.Consumer,
    null,
    function (_ref) {
      var resolvedRoles = _ref.resolvedRoles;
      return React.createElement(
        "div",
        {
          "aria-selected": selected,
          className: css(stylesheet$3(_extends$5({ selected: selected, highlighted: highlighted }, props), resolvedRoles)),
          id: id,
          onClick: handleClick,
          onKeyDown: handleKeyDown,
          onMouseDown: onMouseDown,
          onMouseMove: onMouseMove,
          role: "option",
          tabIndex: "0"
        },
        children
      );
    }
  );
}

OptionWrapper.propTypes = {
  children: PropTypes.node,
  highlighted: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  selected: PropTypes.bool
};

var OptionPresenter = function (_Component) {
  _inherits(OptionPresenter, _Component);

  function OptionPresenter() {
    _classCallCheck(this, OptionPresenter);

    return _possibleConstructorReturn(this, (OptionPresenter.__proto__ || Object.getPrototypeOf(OptionPresenter)).apply(this, arguments));
  }

  _createClass(OptionPresenter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          selected = _props.selected,
          otherProps = _objectWithoutProperties$3(_props, ["children", "selected"]);

      return React.createElement(
        ThemeContext$1.Consumer,
        null,
        function (_ref2) {
          var metadata = _ref2.metadata;

          var Icon = metadata.densityId === "medium-density" ? CheckmarkSUI : CheckmarkXsUI;
          return React.createElement(
            OptionWrapper,
            _extends$5({ selected: selected }, otherProps),
            React.createElement(
              "span",
              null,
              children
            ),
            selected && React.createElement(
              "div",
              null,
              React.createElement(Icon, { color: "#087AAD" })
            )
          );
        }
      );
    }
  }]);

  return OptionPresenter;
}(Component);

OptionPresenter.propTypes = {
  /**
   * Visual representation of the option
   */
  children: PropTypes.node,
  /**
   * Indicates the option is currently highlighted. This is comparable to hover state, but useful when interacting by keyboard.
   */
  highlighted: PropTypes.bool,
  /**
   * Called when user finishes clicking on an option
   */
  onClick: PropTypes.func,
  /**
   * Called when user begins clicking on an option
   */
  onMouseDown: PropTypes.func,
  /**
   * Called when user moves mouse over the option
   */
  onMouseMove: PropTypes.func,
  /**
   * Indicates the option is currently selected
   */
  selected: PropTypes.bool
};
OptionPresenter.__docgenInfo = {
  "description": "",
  "displayName": "OptionPresenter",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Visual representation of the option"
    },
    "highlighted": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Indicates the option is currently highlighted. This is comparable to hover state, but useful when interacting by keyboard."
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user finishes clicking on an option"
    },
    "onMouseDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user begins clicking on an option"
    },
    "onMouseMove": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when user moves mouse over the option"
    },
    "selected": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Indicates the option is currently selected"
    }
  }
};

/**
 * @typedef {any} OptionMeta
 */

/** @typedef {import("downshift").ControllerStateAndHelpers} DownshiftHelpers */

/**
 * @param {DownshiftHelpers} downshift
 * @returns {function(OptionMeta): boolean}
 */
function createSelectedDeterminer(downshift) {
  var multiple = downshift.multiple,
      selectedItem = downshift.selectedItem,
      selectedItems = downshift.selectedItems;


  return function (option) {
    return multiple ? selectedItems.includes(option) : option === selectedItem;
  };
}

/**
 * @param {DownshiftHelpers} downshift
 * @param {function(Object)} renderOption
 * @returns {function(OptionMeta, number): JSX.Element}
 */
function createOptionRenderer(downshift, renderOption) {
  var formatOption = downshift.formatOption,
      getItemProps = downshift.getItemProps,
      highlightedIndex = downshift.highlightedIndex;

  var isSelected = createSelectedDeterminer(downshift);

  return function (option, index) {
    var result = void 0;
    if (option && option.render !== undefined) {
      result = option.render(option);
    } else if (renderOption !== undefined) {
      result = renderOption(option);
    } else {
      var itemProps = getItemProps({
        index: index,
        key: "option-" + index,
        item: option,
        selected: isSelected(option),
        highlighted: highlightedIndex === index
      });

      result = React.createElement(
        OptionPresenter,
        itemProps,
        formatOption(option)
      );
    }
    return result;
  };
}

/** @typedef {DownshiftHelpers & { options: OptionMeta[] }} RenderOptionsProps */

/**
 * @param {RenderOptionsProps} props
 * @todo Convert into a functional component once `React.Fragment` can be used
 */
function renderOptions(props) {
  var _props$formatOption = props.formatOption,
      formatOption = _props$formatOption === undefined ? function (option) {
    return String(option);
  } : _props$formatOption,
      _props$getItemProps = props.getItemProps,
      getItemProps = _props$getItemProps === undefined ? function (itemProps) {
    return itemProps;
  } : _props$getItemProps,
      highlightedIndex = props.highlightedIndex,
      _props$multiple = props.multiple,
      multiple = _props$multiple === undefined ? false : _props$multiple,
      _props$options = props.options,
      options = _props$options === undefined ? [] : _props$options,
      renderOption = props.renderOption,
      selectedItem = props.selectedItem,
      _props$selectedItems = props.selectedItems,
      selectedItems = _props$selectedItems === undefined ? [] : _props$selectedItems;

  var downshift = {
    formatOption: formatOption,
    getItemProps: getItemProps,
    highlightedIndex: highlightedIndex,
    multiple: multiple,
    selectedItem: selectedItem,
    selectedItems: selectedItems
  };

  var optionRenderer = createOptionRenderer(downshift, renderOption);

  return options.map(optionRenderer);
}

var _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$4(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @typedef {import("./presenters/renderOptions").OptionMeta} OptionMeta */
/** @typedef {import("downshift").ControllerStateAndHelpers} DownshiftHelpers */

var variantTypes = ["line", "box"];

var Dropdown = function (_Component) {
  _inherits$1(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$1(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$1(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value) {
      var onChange = _this.props.onChange;


      if (onChange) {
        onChange(value);
      }
    }, _this.renderPresenter = function (downshift) {
      var _this$props = _this.props,
          children = _this$props.children,
          defaultValue = _this$props.defaultValue,
          disabled = _this$props.disabled,
          formatOption = _this$props.formatOption,
          id = _this$props.id,
          multiple = _this$props.multiple,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          renderOption = _this$props.renderOption,
          required = _this$props.required,
          value = _this$props.value,
          variant = _this$props.variant,
          error = _this$props.error,
          otherProps = _objectWithoutProperties$4(_this$props, ["children", "defaultValue", "disabled", "formatOption", "id", "multiple", "onBlur", "onChange", "onFocus", "options", "placeholder", "renderOption", "required", "value", "variant", "error"]);

      /**
       * The `Wrapper` presenter is used as a function to avoid having to use Downshift's `getRootProps`
       * @see https://github.com/paypal/downshift#getrootprops
       */


      return WrapperPresenter(_extends$6({
        disabled: disabled,
        children: [_this.renderInput(downshift), _this.renderMenu(downshift)]
      }, otherProps));
    }, _temp), _possibleConstructorReturn$1(_this, _ret);
  }

  _createClass$1(Dropdown, [{
    key: "getBehaviorProps",
    value: function getBehaviorProps() {
      var _ref2;

      var _props = this.props,
          id = _props.id,
          multiple = _props.multiple,
          formatOption = _props.formatOption,
          value = _props.value,
          defaultValue = _props.defaultValue;

      var valuePropName = multiple ? "selectedItems" : "selectedItem";
      var defaultValuePropName = multiple ? "initialSelectedItems" : "initialSelectedItem";

      return _ref2 = {
        id: id,
        onChange: this.handleChange,
        itemToString: formatOption
      }, _defineProperty(_ref2, valuePropName, value), _defineProperty(_ref2, defaultValuePropName, defaultValue), _defineProperty(_ref2, "inputValue", this.getInputValue()), _ref2;
    }

    /**
     * The controlled value for the input element
     * @see https://github.com/paypal/downshift#inputvalue
     * @returns {string|undefined}
     */

  }, {
    key: "getInputValue",
    value: function getInputValue() {
      var _props2 = this.props,
          multiple = _props2.multiple,
          formatOption = _props2.formatOption,
          value = _props2.value;


      if (value === undefined) {
        return undefined;
      }
      if (multiple) {
        return value.map(formatOption).join(", ");
      }

      return formatOption(value);
    }

    /**
     * > Why not just pass the `props.onChange` directly to Downshift?
     *
     *  Downshift provides all of it's helpers and state to `onChange`.
     *  We don't want to expose the entire Downshift API to consumers.
     *
     * @param {OptionMeta | OptionMeta[]} value
     * @param {DownshiftHelpers} downshift
     */

  }, {
    key: "renderInput",


    /**
     * @param {DownshiftHelpers} downshift
     * @returns {JSX.Element}
     */
    value: function renderInput(downshift) {
      var id = downshift.id,
          isOpen = downshift.isOpen,
          toggleMenu = downshift.toggleMenu,
          getInputProps = downshift.getInputProps;

      var _props3 = this.props,
          placeholder = _props3.placeholder,
          disabled = _props3.disabled,
          required = _props3.required,
          onBlur = _props3.onBlur,
          onFocus = _props3.onFocus,
          variant = _props3.variant,
          error = _props3.error,
          otherProps = _objectWithoutProperties$4(_props3, ["placeholder", "disabled", "required", "onBlur", "onFocus", "variant", "error"]);

      var className = otherProps.className;

      var inputClassName = className && className.split(" ").reduce(function (acc, cur) {
        return cx(acc, cur.trim() + "-input-wrapper");
      }, "");

      var inputProps = getInputProps({
        id: id,
        error: error,
        placeholder: placeholder,
        disabled: disabled,
        isOpen: isOpen,
        required: required,
        onBlur: onBlur,
        onFocus: onFocus,
        onClick: toggleMenu,
        variant: variant,
        className: inputClassName
      });

      return React.createElement(InputPresenter, _extends$6({ key: "input" }, inputProps));
    }

    /**
     * @param {DownshiftHelpers} downshift
     * @returns {JSX.Element}
     */

  }, {
    key: "renderMenu",
    value: function renderMenu(downshift) {
      var getItemProps = downshift.getItemProps,
          getMenuProps = downshift.getMenuProps,
          highlightedIndex = downshift.highlightedIndex,
          isOpen = downshift.isOpen,
          selectedItem = downshift.selectedItem,
          selectedItems = downshift.selectedItems;

      var _props4 = this.props,
          formatOption = _props4.formatOption,
          multiple = _props4.multiple,
          options = _props4.options,
          renderOption = _props4.renderOption,
          otherProps = _objectWithoutProperties$4(_props4, ["formatOption", "multiple", "options", "renderOption"]);

      var className = otherProps.className;


      var menuClassName = className && className.split(" ").reduce(function (acc, cur) {
        return cx(acc, cur.trim() + "-menu-wrapper");
      }, "");

      var menuProps = getMenuProps({
        isOpen: isOpen,
        refKey: "innerRef",
        className: menuClassName
      });

      var children = renderOptions({
        formatOption: formatOption,
        getItemProps: getItemProps,
        highlightedIndex: highlightedIndex,
        multiple: multiple,
        options: options,
        renderOption: renderOption,
        selectedItem: selectedItem,
        selectedItems: selectedItems
      });

      return React.createElement(
        MenuPresenter,
        _extends$6({ key: "menu" }, menuProps),
        children
      );
    }

    /**
     * @param {DownshiftHelpers} downshift
     * @returns {JSX.Element}
     */

  }, {
    key: "render",
    value: function render() {
      var multiple = this.props.multiple;

      var Behavior = multiple ? MultiDownshift : Downshift;

      return React.createElement(
        Behavior,
        this.getBehaviorProps(),
        this.renderPresenter
      );
    }
  }]);

  return Dropdown;
}(Component);

Dropdown.propTypes = {
  /**
   * The default value when the component is uncontrolled
   */
  defaultValue: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]),
  /**
   * Prevents user actions on the field
   */
  disabled: PropTypes.bool,
  /**
   * Used to format options into human readable strings
   *
   * Note that if both formatOption and renderOption are provided,
   * renderOption will take precedence
   */
  formatOption: PropTypes.func,
  /**
   * HTML ID attribute
   */
  id: PropTypes.string,
  /**
   * Enables multiple selection
   */
  multiple: PropTypes.bool,
  /**
   * Called when the text field is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Called with the selected option when the value changes
   */
  onChange: PropTypes.func,
  /**
   * Called when the text field is focused
   */
  onFocus: PropTypes.func,
  /**
   * An array of unique values of any type except `undefined`
   */
  options: PropTypes.arrayOf(PropTypes.any),
  /**
   * Placeholder text to render when an option has not been selected
   */
  placeholder: PropTypes.string,
  /**
   * When present, this function is used to render each option.  Each
   * option is passed as an argument. If any option has Option.render
   * prop present, that will take precedence and this
   * function will not be called for that option.
   *
   * Similarly if both formatOption and renderOption are provided,
   * renderOption will take precedence
   */
  renderOption: PropTypes.func,
  /**
   * Text describing why the field is required
   */
  required: PropTypes.string,
  /**
   * An array of objects to choose from
   */
  value: PropTypes.oneOfType([PropTypes.any, PropTypes.arrayOf(PropTypes.any)]),
  /**
   * The visual variant of the textarea
   */
  variant: PropTypes.oneOf(variantTypes),
  /**
   * Specifies if the value provided is wrong
   */
  error: PropTypes.bool
};
Dropdown.defaultProps = {
  /**
   * @param {OptionMeta} option
   * @returns {string}
   */
  formatOption: function formatOption(option) {
    return option ? String(option) : "";
  }
};
Dropdown.__docgenInfo = {
  "description": "",
  "displayName": "Dropdown",
  "props": {
    "defaultValue": {
      "type": {
        "name": "union",
        "value": [{
          "name": "any"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "any"
          }
        }]
      },
      "required": false,
      "description": "The default value when the component is uncontrolled"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Prevents user actions on the field"
    },
    "formatOption": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Used to format options into human readable strings\n\nNote that if both formatOption and renderOption are provided,\nrenderOption will take precedence",
      "defaultValue": {
        "value": "function(option) {\n  return option ? String(option) : \"\";\n}",
        "computed": false
      }
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "HTML ID attribute"
    },
    "multiple": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Enables multiple selection"
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when the text field is blurred"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called with the selected option when the value changes"
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Called when the text field is focused"
    },
    "options": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "any"
        }
      },
      "required": false,
      "description": "An array of unique values of any type except `undefined`"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Placeholder text to render when an option has not been selected"
    },
    "renderOption": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "When present, this function is used to render each option.  Each\noption is passed as an argument. If any option has Option.render\nprop present, that will take precedence and this\nfunction will not be called for that option.\n\nSimilarly if both formatOption and renderOption are provided,\nrenderOption will take precedence"
    },
    "required": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text describing why the field is required"
    },
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "any"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "any"
          }
        }]
      },
      "required": false,
      "description": "An array of objects to choose from"
    },
    "variant": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"line\"",
          "computed": false
        }, {
          "value": "\"box\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "The visual variant of the textarea"
    },
    "error": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Specifies if the value provided is wrong"
    }
  }
};

export default Dropdown;
